import { ClockIcon, LocationIcon } from '@/components/icon';
import { ekDomain, ROUTES } from '@/configs/constants';
import { LocationBike } from '@/types/http-payload/locationBike';
import { isPathEk } from '@/utils/routes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

interface Props {
    item: LocationBike
}

export default observer(function LocationItem({ item }: Props) {
    // hook
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const isEk = isPathEk(pathname);

    // functions
    const urlViewLocationDetail = (id: string | undefined): string => {
        if (id) {
            return isEk ?
                `/${ekDomain}/${ROUTES.locationList.href}/${ROUTES.locationDetailEnduser.href}/${id}` :
                `/${ROUTES.locationList.href}/${ROUTES.locationDetailEnduser.href}/${id}`;
        }
        return '#';
    };

    const showTime = (location: LocationBike): string => {
        return item?.isShow24h ?
            t('words_title.open_24h') :
            `${item?.openTimeFrom?.split(':').slice(0, 2).join(':') || '--'} - ${item?.openTimeTo?.split(':').slice(0, 2).join(':') || '--'}`;
    };

    return (
        <div className='bg-background px-[20px] py-[30px] border border-border-gray2 rounded-[9.255px] flex flex-col gap-[20px]'>
            {/* Image */}
            <Link to={urlViewLocationDetail(item?.id)}>
                <div
                    className='h-[180px] w-full bg-no-repeat bg-center bg-cover bg-background-img rounded-[7.712px]'
                    style={{
                        backgroundImage: `url(${item?.locationImage || ''})`
                    }}
                />
            </Link>

            {/* Content */}
            <div className='pb-[20px] border-b border-border-gray3'>
                <Link to={urlViewLocationDetail(item?.id)}>
                    <div className='box-title line-clamp-1'>{item?.name || '--'}</div>
                </Link>

                <div className='flex justify-start items-center gap-[5px] mt-[10px] mb-[5px]'>
                    <LocationIcon className='w-[16px] h-[16px] flex justify-center items-center' />
                    <div className='text-fs-mid14 leading-lh-sma14 text-text-fc-gray font-medium line-clamp-1'>
                        {item?.address || '--'}
                    </div>
                </div>
                <div className='flex justify-start items-center gap-[5px]'>
                    <ClockIcon className='w-[16px] h-[16px] flex justify-center items-center' />
                    <div className='text-fs-mid14 leading-lh-sma14 text-text-fc-gray font-medium line-clamp-1'>
                        {showTime(item)}
                    </div>
                </div>
            </div>

            {/* Note */}
            <div className='text-fs-mid14 leading-lh-mid14 text-text-fc-gray font-medium line-clamp-1'>
                {item?.access || '--'}
            </div>
        </div>
    );
});
